var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93739 0C3.55379 0 0 3.55379 0 7.93759C0 12.3212 3.55379 15.8751 7.93739 15.8751C12.321 15.8751 15.8748 12.3212 15.8748 7.93759C15.8748 3.55379 12.321 0 7.93739 0Z",
    fill: "#0076A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3762 4.66283C12.2544 4.54098 12.0577 4.54098 11.936 4.66283L5.92222 10.6761L3.96102 8.71485C3.83926 8.593 3.64165 8.593 3.51989 8.71485C3.39813 8.83651 3.39813 9.03375 3.51989 9.1556L5.70212 11.3374C5.763 11.3981 5.84261 11.4286 5.92222 11.4286C6.00183 11.4286 6.08237 11.3981 6.14325 11.3374L12.3762 5.10349C12.4979 4.98173 12.4979 4.78458 12.3762 4.66283Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.8efd3a63a2eb9c9974598a7cd88993fb.svg";
export { ForwardRef as ReactComponent };